/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseLong } from '../../models/api-response-long';
import { OtpDto } from '../../models/otp-dto';

export interface VerifyOtpSignUp$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: OtpDto
}

export function verifyOtpSignUp(http: HttpClient, rootUrl: string, params: VerifyOtpSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
  const rb = new RequestBuilder(rootUrl, verifyOtpSignUp.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseLong>;
    })
  );
}

verifyOtpSignUp.PATH = '/v1/api/ui/public/sign-up/otp/verify';
